import { ModalContent, ModalProps } from '@ds';
import { DrawerModal } from '@ui';
import { useCaseNotesStore } from '@/store/case-notes.store';
import { CaseNote } from '@/api/apis/case';
import { NotesListModalContent, AddNoteModalContent, EditNoteModalContent, RemoveNoteModalContent } from './components';

type CaseNotesDrawerProps = Omit<ModalProps, 'children'> & {
  caseId: string;
  notes: CaseNote[];
};

export const CaseNotesDrawer = ({ caseId, notes, ...props }: CaseNotesDrawerProps) => {
  const isCreateNote = useCaseNotesStore.use.createNote();
  const isEditNote = useCaseNotesStore.use.editNote();
  const isRemoveNote = useCaseNotesStore.use.removeNote();
  const hideCloseButton = Boolean(isCreateNote || isEditNote || isRemoveNote);

  const getModalContent = () => {
    switch (true) {
      case isCreateNote:
        return <AddNoteModalContent caseId={caseId} />;
      case Boolean(isEditNote):
        return <EditNoteModalContent caseId={caseId} />;
      case Boolean(isRemoveNote):
        return <RemoveNoteModalContent caseId={caseId} />;
      default:
        return <NotesListModalContent caseId={caseId} notes={notes} />;
    }
  };

  return (
    <DrawerModal {...props} className="max-w-[540px]" hideCloseButton={hideCloseButton}>
      <ModalContent>{getModalContent()}</ModalContent>
    </DrawerModal>
  );
};
